export async function requestApcAI(data) {
  const { auth, functions } = await import("../firebase");
  if (!auth.currentUser) throw new Error("Sign in to FilingStack to use the optional AI coach. All core practice tools work without signing in.");
  try {
    const result = await functions.httpsCallable("apcStudyAssistant", { timeout: 180000 })(data);
    return result.data;
  } catch (error) {
    const code = String(error.code || "");
    if (/not-found|unimplemented/.test(code)) throw new Error("The AI coach has not been deployed yet. You can continue with the study notes, checklist and answer outlines.");
    if (/resource-exhausted/.test(code)) throw new Error("The AI practice limit has been reached. Please try again later.");
    if (/unauthenticated/.test(code)) throw new Error("Please sign in again to use the AI coach.");
    if (/invalid-argument/.test(code)) throw new Error(error.message || "Check the case details and source files.");
    if (/permission-denied|failed-precondition/.test(code)) throw new Error(error.message || "AI access is not configured yet.");
    throw new Error("The AI coach is unavailable. Your response is saved; use the self-review checklist and try again later.");
  }
}

export function readStudyFile(file) {
  if (!file || file.size > 2 * 1024 * 1024) return Promise.reject(new Error("Choose a PDF or text file no larger than 2 MB."));
  if (!/\.(pdf|txt)$/i.test(file.name)) return Promise.reject(new Error("Use a .pdf or .txt source file."));
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error(`Could not read ${file.name}.`));
    reader.onload = () => resolve({ name: file.name, base64: String(reader.result).split(",")[1], type: /\.pdf$/i.test(file.name) ? "pdf" : "txt" });
    reader.readAsDataURL(file);
  });
}
